<script setup lang="ts">
import { Primitive } from 'reka-ui';

withDefaults(defineProps<{
	as?: string;
	asChild?: boolean;
	cols?: number;
}>(), {
	cols: 12,
});
</script>

<template>
	<Primitive
		:is="as"
		:as-child
		class="grid gap-2"
		:style="{ gridTemplateColumns: `repeat(${cols}, minmax(0, 1fr))` }"
	>
		<slot />
	</Primitive>
</template>
